import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import {notificationsService} from '@/api/services/notification';
import {consultationService} from '@/api/services/consultation';
import {reactive} from 'vue';
import EventsAndActivityPanelCard
  from "@/components/Layout/LayoutV2/EventsAndActivityPanel/EventsAndActivityPanelCard.vue";
import NotificationsComponent from "@/components/Layout/LayoutV2/Notifications/NotificationsComponent.vue";
import {activityService} from "@/api/services/activity";
import ActivityPanelType from "@/components/Layout/LayoutV2/EventsAndActivityPanel/ActivityPanelType.vue";
import EventsActivity from "@/components/Layout/LayoutV2/EventsAndActivityPanel/Cards/EventsActivity.vue";
import {isEmptyObject} from "@/components/Helpers/Utils";


export default /*@__PURE__*/_defineComponent({
  __name: 'EventsAndActivityPanel',
  setup(__props) {

const state = reactive({
  notifications: [] as any,
  event: null as any,
  recentActivities: [] as any,
});

const getNotifications = () => {
  notificationsService.index().then((response) => {
    state.notifications = response.data.filter((notification: any) => !notification.read);
  });
}

const markRead = (notification: object) => {
  notificationsService.read(notification.id).then(() => {
    state.notifications = state.notifications.filter((item: any) => item.id !== notification.id);
    getNotifications();
  });
}

const getEvent = () => {
  consultationService.mostRecent().then((response) => {
    state.event = response;
  });
}

const getRecentActivities = () => {
  activityService.index({
    per_page: 1
  }).then((response) => {
    state.recentActivities = response.data;
  });
}

getNotifications();
getEvent();
getRecentActivities();

return (_ctx: any,_cache: any) => {
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, { class: "mt-6 mx-0" }, {
    default: _withCtx(() => [
      (state.notifications.length > 0)
        ? (_openBlock(), _createBlock(NotificationsComponent, {
            key: 0,
            notifications: state.notifications,
            onOnClose: markRead
          }, null, 8, ["notifications"]))
        : _createCommentVNode("", true),
      (_unref(isEmptyObject)(state.event))
        ? (_openBlock(), _createBlock(EventsAndActivityPanelCard, { key: 1 }))
        : (_openBlock(), _createBlock(EventsActivity, {
            key: 2,
            event: state.event
          }, null, 8, ["event"])),
      (state.recentActivities.length === 0)
        ? (_openBlock(), _createBlock(EventsAndActivityPanelCard, {
            key: 3,
            "empty-content-custom-class": "empty-message",
            firstRow: "You have no recent",
            icon: "basket-icon",
            secondRow: "activity",
            "sub-title": "Activity",
            title: "Recent Activity"
          }))
        : (_openBlock(), _createBlock(ActivityPanelType, {
            key: 4,
            "recent-activity": state.recentActivities[0]
          }, null, 8, ["recent-activity"]))
    ]),
    _: 1
  }))
}
}

})